import styled from '@emotion/styled';
import { theme } from 'styles/theme/theme';

export const MainBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  /*
   * Кликабельная строка получает подсветку, не сдвигая раскладку: отступ внутрь компенсирован таким же
   * отрицательным внешним, поэтому аватар и бар стоят там же, где у неактивной строки.
   */
  &.clickable {
    margin: -4px -8px;
    padding: 4px 8px;
    border-radius: ${theme.radii.card};
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: ${({ theme }) => theme.colors.AccentCornsilk};
    }

    &:focus-visible {
      outline: 2px solid ${({ theme }) => theme.colors.AccentNaplesYellow};
      outline-offset: -2px;
    }
  }
`;

export const Avatar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;

  width: 28px;
  min-width: 28px;
  height: 28px;
  min-height: 28px;
  border-radius: ${theme.radii.control};
  border: 0.5px solid ${({ theme }) => theme.colors.WhiteGray};

  & img {
    width: 28px;
    height: 28px;
    object-fit: contain;
  }
`;

export const Bar = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Track = styled.div`
  height: 6px;
  border-radius: ${theme.radii.pill};
  background: ${({ theme }) => theme.colors.WhiteGray10};
  overflow: hidden;
`;

/**
 * Ширина выставляется в два прохода (0 → значение), чтобы CSS-переход реально сыграл —
 * см. `useMountedAfterFrame` в компоненте. `transitionDelay` растягивает заполнение
 * построчно, а не разом.
 */
export const Fill = styled.div<{ $color: string; $delayMs: number }>`
  height: 100%;
  width: 0%;
  border-radius: ${theme.radii.pill};
  background: ${({ $color }) => $color};
  transition: width 0.7s cubic-bezier(0.16, 1, 0.3, 1);
  transition-delay: ${({ $delayMs }) => $delayMs}ms;

  &.filled {
    width: var(--target-width);
  }
`;
